<template>
  <div class="d-flex justify-center align-center flex-column" style="min-height: 90vh">
  <div>
    <v-card class="" width="370px" :height="getSelectedCompany.role == 'admin' || getSelectedCompany.role == 'owner' ? '280px' : '240px'"
  
  elevation="4"
>
<v-row class="d-flex justify-center">
<div >
 <v-avatar
      slot="icon"
      color="#dcd8f3"
      size="70"
      class="mr-2 d-flex justify-center mt-4"
    >
      <v-icon 
        icon="mdi-exclamation" 
        color="#2a206a"
        large
      >
        mdi-exclamation
      </v-icon>
    </v-avatar>
    </div>
    </v-row>
 <v-row>  <v-col cols="12" class="d-flex justify-center mt-2"> <div>  <h3 style="color : #13865a">Suspended Company</h3> </div> </v-col> </v-row>
  <div class="d-flex justify-center mt-2 mx-12">  <h5 v-if="getSelectedCompany.role == 'admin' || getSelectedCompany.role == 'owner'" style="color : #2a206a">Oh Snap! This company has been suspended. Your progress has not been lost. please contact with support team</h5>  <h5 v-else style="color : #2a206a">Oh Snap! This company has been suspended. Contact to your admin for further information</h5>   </div>
  <div v-if="getSelectedCompany.role == 'admin' || getSelectedCompany.role == 'owner'"  class="d-flex justify-center mt-5 mx-16"> <a style='text-decoration: none;' target='_blank' href= 'https://gigstimer.com/contact-us/'><v-btn dark outlined color="#13865a">Contact Sales</v-btn></a></div>

</v-card>

  </div>
    <!-- <div>
      <v-row>      <v-avatar
      slot="icon"
      color="#2a206a"
      size="40"
      class="mr-2 mt-n2"
    >
      <v-icon
        icon="mdi-lock"
        color="white"
      >
        mdi-lock
      </v-icon>
    </v-avatar>   <pre> Oh Snap! This company has been suspended.</pre> </v-row>
    </div>
    <div>
   <a>   <v-btn target="_blank" href="https://gigstimer.com/contact-us/" v-if="getSelectedCompany.role!='employee' && getSelectedCompany.role!='team-manager'" color="green" class="my-4 white--text">Contact to Support department</v-btn> </a>
    </div> -->
  </div>
</template>
<script>
import { eventBus } from "@/main";
import {mapGetters} from "vuex";
import Swal from "sweetalert2";
export default {
  name: "ExpireCompanyView",
  components: {},
  computed:{
    ...mapGetters(["getSelectedCompany"])
  },
  mounted(){
 //   this.hello();
  },
  methods:{
    // goToSubscriptionPage(){
    //   eventBus.$emit("purchaseSubsciption","chart-tab");
    //   this.$router.push({ name: "billing" })
    // }
    hello(){
        Swal.fire({
        title: "Suspended Company",
        html: "Dear Customer Your account has been suspended. Your progress has not been lost. please contact with support team.",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "<a style='text-decoration: none; color: #13865a' target='_blank' href= 'https://gigstimer.com/contact-us/'>Contact Us</a>",
        showConfirmButton: false,
        reverseButtons: true,
      }).then((result) => {
      });
    }
  }
};
</script>
